<template>
  <div>
    <v-navigation-drawer
      v-if="this.$store.getters.authenticated"
      v-model="sidebar.display"
      app
    >
      <v-list
        v-if="false"
        color="blue-darken-3"
      >
        <v-list-item class="px-2 pt-3">
          <v-list-item-title class="title">
            <v-select
              v-model="$store.state.account.id"
              :items="$store.state.accounts"
              item-title="name"
              item-value="id"
              label="Account"
              @update:model-value="switchAccount()"
            ></v-select>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          class="px-2"
        >
          <v-list-item-subtitle>{{ this.$store.state.user.name }} {{ this.$store.state.user.email }}</v-list-item-subtitle>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-item
          to="/"
        >
          <template #prepend>
            <v-icon>mdi-view-dashboard</v-icon>
          </template>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="getAccountRoute('/workflows')"
        >
          <template #prepend>
            <v-icon>mdi-cogs</v-icon>
          </template>
          <v-list-item-title>Workflows</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="getAccountRoute('/linkedin-conversations')"
        >
          <template #prepend>
            <v-icon>mdi-forum</v-icon>
          </template>
          <v-list-item-title>Conversations</v-list-item-title>
        </v-list-item>
        <v-list-group
          v-if="account"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-account-box-multiple"
            >
              <v-list-item-title>Contacts</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            :to="getAccountRoute('/contacts')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-account-box-multiple</v-icon>
            </template>
            <v-list-item-title>Contacts</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="getAccountRoute('/companies')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-briefcase</v-icon>
            </template>
            <v-list-item-title>Companies</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/contact-lists')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-table-account</v-icon>
            </template>
            <v-list-item-title>Contact Lists</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="getAccountRoute('/contacts-import')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-cloud-upload</v-icon>
            </template>
            <v-list-item-title>Import from File</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          :to="getAccountRoute('/task-boards')"
        >
          <template #prepend>
            <v-icon>mdi-bullseye-arrow</v-icon>
          </template>
          <v-list-item-title>Tasks</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="getAccountRoute('/notes')"
        >
          <template #prepend>
            <v-icon>mdi-note</v-icon>
          </template>
          <v-list-item-title>Notes</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="getAccountRoute('/tags')"
        >
          <template #prepend>
            <v-icon>mdi-tag</v-icon>
          </template>
          <v-list-item-title>Tags</v-list-item-title>
        </v-list-item>
        <v-list-group
          v-if="account"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-linkedin"
            >
              <v-list-item-title>LinkedIn</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            :to="getAccountRoute('/linkedin')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-account-box-multiple</v-icon>
            </template>
            <v-list-item-title>Accounts</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-conversations')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-forum</v-icon>
            </template>
            <v-list-item-title>Conversations</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-searches')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-account-search</v-icon>
            </template>
            <v-list-item-title>Searches</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-connections')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-account-multiple</v-icon>
            </template>
            <v-list-item-title>Connections</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-if="account"
            class="pl-2"
            subgroup
          >
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <v-list-item-title>Invitations</v-list-item-title>
              </v-list-item>
            </template>
            <v-list-item
              :to="getAccountRoute('/linkedin-invitations-received')"
              class="pl-6"
            >
              <template #prepend>
                <v-icon>mdi-account-multiple-plus</v-icon>
              </template>
              <v-list-item-title>Received</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="getAccountRoute('/linkedin-invitations-sent')"
              class="pl-6"
            >
              <template #prepend>
                <v-icon>mdi-account-multiple-plus-outline</v-icon>
              </template>
              <v-list-item-title>Sent</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item
            :to="getAccountRoute('/linkedin-suggestions')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-account-question</v-icon>
            </template>
            <v-list-item-title>Suggestions</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-views')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-target-account</v-icon>
            </template>
            <v-list-item-title>Views</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="getAccountRoute('/linkedin-groups')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-account-group</v-icon>
            </template>
            <v-list-item-title>Groups</v-list-item-title>
          </v-list-item>

          <v-list-group
            v-if="account"
            class="pl-2"
            subgroup
          >
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <v-list-item-title>Company Page</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item
              :to="getAccountRoute('/linkedin-company-posts')"
              class="pl-6"
            >
              <template #prepend>
                <v-icon>mdi-note-text</v-icon>
              </template>
              <v-list-item-title>Posts</v-list-item-title>
            </v-list-item>

            <v-list-item
              :to="getAccountRoute('/linkedin-company-invitations-sent')"
              class="pl-6"
            >
              <template #prepend>
                <v-icon>mdi-briefcase-plus</v-icon>
              </template>
              <v-list-item-title>Invitations Sent</v-list-item-title>
            </v-list-item>
          </v-list-group>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="account"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-wrench"
            >
              <v-list-item-title>
                Integrations
                <base-info-icon
                  v-if="!$store.getters.canUseApiIntegrations"
                  label="These features are available on Pro and Max plans (or legacy Regular/Premium)."
                  to="/billing"
                />
              </v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            :to="getAccountRoute('/integrations')"
            class="pl-6"
            :disabled="!$store.getters.canUseApiIntegrations"
          >
            <template #prepend>
              <v-icon>mdi-api</v-icon>
            </template>
            <v-list-item-title>API</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="getAccountRoute('/webhooks')"
            class="pl-6"
            :disabled="!$store.getters.canUseApiIntegrations"
          >
            <template #prepend>
              <v-icon>mdi-webhook</v-icon>
            </template>
            <v-list-item-title>Webhooks</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-group
          v-if="account"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-chart-box"
            >
              <v-list-item-title>Reports</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item
            :to="getAccountRoute('/overview')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-calendar</v-icon>
            </template>
            <v-list-item-title>Overview</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="getAccountRoute('/reports')"
            class="pl-6"
          >
            <template #prepend>
              <v-icon>mdi-chart-areaspline</v-icon>
            </template>
            <v-list-item-title>Charts</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list
        nav
      >
        <v-list-item
          to="/accounts"
        >
          <template #prepend>
            <v-icon>mdi-domain</v-icon>
          </template>
          <v-list-item-title>Accounts</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/settings"
        >
          <template #prepend>
            <v-icon>mdi-tune</v-icon>
          </template>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider v-if="$store.getters.isOwner"></v-divider>

      <v-list
        v-if="$store.getters.isOwner"
        nav
      >

        <v-list-subheader>Account Management</v-list-subheader>

        <v-list-item
          :to="getAccountRoute('/account')"
        >
          <template #prepend>
            <v-icon>mdi-cog</v-icon>
          </template>
          <v-list-item-title>Configuration</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="getAccountRoute('/users')"
        >
          <template #prepend>
            <v-icon>mdi-account-group</v-icon>
          </template>
          <v-list-item-title>Manage Users</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="getAccountRoute('/billing')"
        >
          <template #prepend>
            <v-icon>mdi-credit-card-outline</v-icon>
          </template>
          <v-list-item-title>Manage Billing</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

    </v-navigation-drawer>

    <v-app-bar
      color="blue-darken-3"
      elevation="0"
      app
      density="compact"
      :absolute="!this.$store.getters.authenticated"
      :scroll-behavior="!this.$store.getters.authenticated ? 'hide' : undefined"
    >
      <v-app-bar-nav-icon
        v-if="this.$store.getters.authenticated"
        @click="sidebar.display = !sidebar.display"
      ></v-app-bar-nav-icon>

      <v-toolbar-title v-if="!smallMobileScreen420"></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip
          v-if="$route.name !== 'Global Search' && $store.getters.authenticated"
          location="bottom"
      >
        <template #activator="{ props }">
          <v-btn
            :to="getAccountRoute('/search')"
            icon
            class="mx-1"
            size="small"
            v-bind="props"
          >
            <v-icon size="small" disabled>mdi-magnify</v-icon>
          </v-btn>
        </template>
        <span>Global Search</span>
      </v-tooltip>

      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn
            href="https://docs.webwalker.io/wiki/"
            target="_blank"
            icon
            class="mx-1"
            size="small"
            v-bind="props"
          >
            <v-icon size="small">mdi-book-open-outline</v-icon>
          </v-btn>
        </template>
        <span>Knowledge Base</span>
      </v-tooltip>

      <main-nav-notifications
        v-if="$store.getters.authenticated"
      ></main-nav-notifications>

      <v-btn
        v-if="$store.getters.authenticated"
        to="/settings"
        icon
        class="mx-1"
        size="small"
      >
        <v-icon size="small">mdi-account-circle</v-icon>
      </v-btn>

      <div
        v-if="$store.getters.authenticated"
      >
        <v-tooltip v-if="$store.state.isDarkMode" location="bottom">
          <template #activator="{ props }">
            <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', false)">
              <v-icon size="small" color="yellow" class="mr-1">mdi-moon-waxing-crescent</v-icon>
            </v-btn>
          </template>
          <span>Disable dark mode</span>
        </v-tooltip>
        <v-tooltip v-else location="bottom">
          <template #activator="{ props }">
            <v-btn v-bind="props" size="small" icon @click="$store.dispatch('switchDarkMode', true)">
              <v-icon size="small" color="yellow">mdi-white-balance-sunny</v-icon>
            </v-btn>
          </template>
          <span>Enable dark mode</span>
        </v-tooltip>
      </div>

      <v-divider
        v-if="$store.getters.authenticated"
        v-show="!this.isAuthView"
        vertical
        class="ml-2 mr-0 mr-sm-4"
      ></v-divider>

      <v-menu
        :theme="dropdownTheme"
        v-if="$store.getters.authenticated"
        location="bottom start"
      >
        <template #activator="{ props }">
          <v-btn
            variant="text"
            class="main-nav-btn mx-1"
            size="small"
            v-bind="props"
          >
            <v-icon class="mr-0 mr-sm-3" size="small">mdi-domain</v-icon>
            <span v-if="!smallMobileScreen420">{{ ((account) ? account.name : 'Select Account') }}</span>
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-subheader style="max-height: 30px;">{{ this.$store.state.user.name }} {{ this.$store.state.user.email }}</v-list-subheader>
          <v-list-subheader
            v-if="account"
          >{{ account.name }}</v-list-subheader>

          <v-divider></v-divider>

          <v-list-subheader>Account Management</v-list-subheader>

          <v-list-item
            :to="getAccountRoute('/account')"
            class="pl-6"
            density="compact"
          >
            <v-list-item-title>Configuration</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-cog</v-icon>
            </template>
          </v-list-item>

          <v-list-item
            v-if="$store.getters.isOwner"
            :to="getAccountRoute('/users')"
            density="compact"
          >
            <v-list-item-title>Manage Users</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-account-group</v-icon>
            </template>
          </v-list-item>

          <v-list-item
            v-if="$store.getters.isOwner"
            :to="getAccountRoute('/billing')"
            density="compact"
          >
            <v-list-item-title>Manage Billing</v-list-item-title>
            <template #append>
              <v-icon size="small">mdi-credit-card-outline</v-icon>
            </template>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            to="/accounts"
          >
            <v-list-item-title>My Accounts</v-list-item-title>
            <template #append>
              <v-icon>mdi-domain</v-icon>
            </template>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            v-for="(acc, index) in this.$store.state.accounts"
            :key="index"
            :disabled="acc.id == account.id"
            @click="switchAccountRoute(acc)"
          >
            <v-list-item-title>{{ acc.name }}</v-list-item-title>
            <template #append>
              <v-icon>mdi-location-enter</v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-divider
        v-if="$store.getters.authenticated"
        v-show="!this.isAuthView"
        vertical
        class="ml-0 ml-sm-2 mr-0 mr-sm-4"
      ></v-divider>

      <v-btn
        class="main-nav-btn mx-2"
        size="small"
        variant="text"
        v-if="!this.$store.getters.authenticated"
        :to="{name: 'Login'}"
      >
        <v-icon class="mr-1" size="small">mdi-login</v-icon>
        Login
      </v-btn>
      <v-btn
        class="main-nav-btn mx-2"
        size="small"
        variant="text"
        v-if="!this.$store.getters.authenticated"
        :to="{name: 'Sign Up'}"
      >
        Sign Up
      </v-btn>
      <v-btn
        class="mx-2"
        icon
        size="small"
        v-if="this.$store.getters.authenticated"
        @click="logoutConfirmation = true"
      >
        <v-icon size="small">mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <base-dialog-confirmation
      v-model="logoutConfirmation"
      prompt="Do you really want to logout?"
      confirm-text="Logout"
      confirm-color="red"
      @confirm="logout"
      @cancel="logoutConfirmation = false"
    ></base-dialog-confirmation>
  </div>
</template>

<script>
import MainNavNotifications from '@/components/layout/MainNavNotifications.vue';

export default {
  name: 'MainNavSidebar',

  components: {
    MainNavNotifications,
  },

  data: () => ({
    logoutConfirmation: false,
    sidebar: {
      display: false,
    },
  }),

  computed: {
    accountId: function () {
      var params = this.$route.params;
      if (params && params['accountId']) return params['accountId'];
      if (this.$store.state.account) return this.$store.state.account.id;
      if (this.$store.state.accounts && this.$store.state.accounts.length) {
        return this.$store.state.accounts[0].id;
      }
      return null;
    },
    account: function () {
      if (!this.$store.state.accounts || !this.accountId) return false;
      return this.$store.state.accounts.find(x => x.id == this.accountId);
    },
    isAuthView() {
      // Check if on auth pages (login, sign up, password reset, etc)
      if (this.$route && this.$route.meta) {
        return this.$route.meta.public;
      }
      return false;
    },
    dropdownTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },
    smallMobileScreen420() {
      return window.screen.width < 420;
    },
  },

  methods: {
    getAccountRoute: function (route) {
      if (!this.accountId) return route;
      return '/account/' + this.accountId + route;
    },
    switchAccount: function () {
      this.$store.commit('setAccount', this.$store.state.accounts.find(x => x.id == this.accountId));
      window.location.reload();
    },
    logout: function () {
      this.$emit('logout');
    },
  },
};
</script>
